import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

//actions:
import { modifyFieldOtrosDatosSemanal } from '../../../actions/cierre_semanal_actions';

//components IntNumberFormatInput
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: 700,
    },
    paperFull: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginBottom: 10,
        height: 105,
        borderBottom: `2px solid ${grey[500]}`,
        borderRight: `2px solid ${grey[500]}`,
        backgroundColor: 'white',
    },
    title: {
        fontSize: 14,
        fontWeight: '500',
        color: 'white',
        padding: '4px 2px 4px 12px',
        backgroundColor: grey[600],
        margin: 0,
    },
    containerThirdRow: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: 10,
    },
    thirRowElement: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        // width: '38%',
        height: 220,
        borderBottom: `2px solid ${grey[500]}`,
        borderRight: `2px solid ${grey[500]}`,
    },
    thirdRowCenter: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '20%',
    },
    halfPaperInsidePanel: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        height: 95,
        borderBottom: `2px solid ${grey[500]}`,
        borderRight: `2px solid ${grey[500]}`,
        '&:first-child': {
            marginBottom: 10,
        }
    },
    halfPaper: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        height: 105,
        borderBottom: `2px solid ${grey[500]}`,
        borderRight: `2px solid ${grey[500]}`,
        '&:first-child': {
            marginBottom: 10,
        }
    },
    textfieldHalf: {
        height: 70,
        margin: '0 auto',
        width: '85%',
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        }        
    },
    inputpropHalf: {
        margin: 'auto 0',
        padding: '8px 0',
        fontSize: 11,
        height: '50%',
    },
    textfieldthirdRowSide: {
        display: 'flex',
        height: '100%',
        margin: '0 auto',
        padding: '0 8px',
        width: '98%',
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
        
    },
    inputthirdRowSide: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',
        fontSize: 11,
        height: '90%',
    },
    textField: {
        display: 'flex',
        height: '100%',
        margin: '0 auto',
        width: '97%',
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    inputprop: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',
        fontSize: 11,
        height: 45,
    },
    greenTitle: {
        backgroundColor: theme.palette.primary.main,
    },
    purpleTitle: {
        backgroundColor: theme.palette.secondary.main,
    },
    blackTitle: {
        backgroundColor: 'black',
    },
    lastRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    paperlast: {
        display: 'flex',
        flexDirection: 'column',
        width: '49%',
        marginBottom: 10,
        height: 105,
        borderBottom: `2px solid ${grey[500]}`,
        borderRight: `2px solid ${grey[500]}`,
        backgroundColor: 'white',
    },
    textfieldLast: {
        width: '93%',
    },
    righText:{
        textAlign: 'right'
    }

});


class CentreSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            obsResumenGeneral: !this.props.otrosDatosCierreSemanal.obsResumenGeneral ? '' : this.props.otrosDatosCierreSemanal.obsResumenGeneral,
            obsResumenBolera: !this.props.otrosDatosCierreSemanal.obsResumenBolera ? '' : this.props.otrosDatosCierreSemanal.obsResumenBolera,
            obsResumenBar: !this.props.otrosDatosCierreSemanal.obsResumenBar ? '' : this.props.otrosDatosCierreSemanal.obsResumenBar,
            hojasReclamacion: !this.props.otrosDatosCierreSemanal.hojasReclamacion ? '' : this.props.otrosDatosCierreSemanal.hojasReclamacion,
            obsResumenAniversarios: !this.props.otrosDatosCierreSemanal.obsResumenAniversarios ? '' : this.props.otrosDatosCierreSemanal.obsResumenAniversarios,
            obsResumenArcade: !this.props.otrosDatosCierreSemanal.obsResumenArcade ? '' : this.props.otrosDatosCierreSemanal.obsResumenArcade,
            obsResumenRRHH: !this.props.otrosDatosCierreSemanal.obsResumenRRHH ? '' : this.props.otrosDatosCierreSemanal.obsResumenRRHH,
            obsResumenInstalaciones: !this.props.otrosDatosCierreSemanal.obsResumenInstalaciones ? '' : this.props.otrosDatosCierreSemanal.obsResumenInstalaciones,
            ventaNormalBar: !this.props.otrosDatosCierreSemanal.ventaNormalBar ? 0 : this.props.otrosDatosCierreSemanal.ventaNormalBar,
            entrKids: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.entrKids,
            resenyas123: !this.props.otrosDatosCierreSemanal.resenyas123 ? 0 : this.props.otrosDatosCierreSemanal.resenyas123,
            resenyas45: !this.props.otrosDatosCierreSemanal.resenyas45 ? 0 : this.props.otrosDatosCierreSemanal.resenyas45,
            cumplesOnline: !this.props.otrosDatosCierreSemanal.cumplesOnline ? 0 : this.props.otrosDatosCierreSemanal.cumplesOnline,
            altasPersonal: !this.props.otrosDatosCierreSemanal.altasPersonal ? 0 : this.props.otrosDatosCierreSemanal.altasPersonal,
            bajasPersonal: !this.props.otrosDatosCierreSemanal.bajasPersonal ? 0 : this.props.otrosDatosCierreSemanal.bajasPersonal,
            amonestaciones: !this.props.otrosDatosCierreSemanal.amonestaciones ? 0 : this.props.otrosDatosCierreSemanal.amonestaciones,

        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreSemanal !== this.props.otrosDatosCierreSemanal) {
            this.setState({
                obsResumenGeneral: !this.props.otrosDatosCierreSemanal.obsResumenGeneral ? '' : this.props.otrosDatosCierreSemanal.obsResumenGeneral,
                obsResumenBolera: !this.props.otrosDatosCierreSemanal.obsResumenBolera ? '' : this.props.otrosDatosCierreSemanal.obsResumenBolera,
                obsResumenBar: !this.props.otrosDatosCierreSemanal.obsResumenBar ? '' : this.props.otrosDatosCierreSemanal.obsResumenBar,
                hojasReclamacion: !this.props.otrosDatosCierreSemanal.hojasReclamacion ? '' : this.props.otrosDatosCierreSemanal.hojasReclamacion,
                obsResumenAniversarios: !this.props.otrosDatosCierreSemanal.obsResumenAniversarios ? '' : this.props.otrosDatosCierreSemanal.obsResumenAniversarios,
                obsResumenArcade: !this.props.otrosDatosCierreSemanal.obsResumenArcade ? '' : this.props.otrosDatosCierreSemanal.obsResumenArcade,
                obsResumenRRHH: !this.props.otrosDatosCierreSemanal.obsResumenRRHH ? '' : this.props.otrosDatosCierreSemanal.obsResumenRRHH,
                obsResumenInstalaciones: !this.props.otrosDatosCierreSemanal.obsResumenInstalaciones ? '' : this.props.otrosDatosCierreSemanal.obsResumenInstalaciones,
                ventaNormalBar: !this.props.otrosDatosCierreSemanal.ventaNormalBar ? 0 : this.props.otrosDatosCierreSemanal.ventaNormalBar,
                entrKids: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.entrKids,
                resenyas123: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.resenyas123,
                resenyas45: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.resenyas45,
                cumplesOnline: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.cumplesOnline,
                altasPersonal: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.altasPersonal,
                bajasPersonal: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.bajasPersonal,
                amonestaciones: !this.props.otrosDatosCierreSemanal.entrKids ? 0 : this.props.otrosDatosCierreSemanal.amonestaciones,

            });
        };
    };


    handleValueChange = (event, field) => {

        this.setState({ ...this.state, [field]: event.target.value });
    };


    onBlur = (event, field) => {

        this.props.modifyFieldOtrosDatosSemanal(field, event.target.value, this.props.otrosDatosCierreSemanal);
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.container}>

                {/* first row */}
                <div className={classes.paperFull}>
                    <p className={classes.title} variant="subtitle1">Resumen General</p>
                    <TextField
                        className={classes.textField}
                        disabled={this.props.isSemanaCerrada ? true : false}
                        placeholder={'Escriba aquí...'}
                        InputProps={{
                            className: classes.inputprop,
                        }}
                        inputProps={{ maxLength: 500 }}
                        id={'obsResumenGeneral'}
                        value={this.state.obsResumenGeneral}
                        variant='outlined'
                        multiline
                        rowsMax="3"
                        onChange={e => this.handleValueChange(e, 'obsResumenGeneral')}
                        onBlur={e => this.onBlur(e, 'obsResumenGeneral')}
                    />
                </div>

                {/* second row */}
                <div className={classes.paperFull}>
                    <p className={`${classes.title} ${classes.greenTitle}`} variant="subtitle1">Resumen Cumpleaños</p>
                    <TextField
                        className={classes.textField}
                        disabled={this.props.isSemanaCerrada ? true : false}
                        placeholder={'Escriba aquí...'}
                        InputProps={{
                            className: classes.inputprop,
                        }}
                        inputProps={{ maxLength: 250 }}
                        id={'obsResumenAniversarios'}
                        value={this.state.obsResumenAniversarios}
                        variant='outlined'
                        multiline
                        rowsMax="3"
                        onChange={e => this.handleValueChange(e, 'obsResumenAniversarios')}
                        onBlur={e => this.onBlur(e, 'obsResumenAniversarios')}
                    />
                </div>

                <div className={classes.containerThirdRow}>
                    {/* third row */}
                    <div className={classes.thirRowElement}>
                        {/* left */}
                        <p className={`${classes.title} ${classes.purpleTitle}`} variant="subtitle1">Google Review</p>
                         {/* up */}
                         <div className={classes.halfPaperInsidePanel}>
                            <p className={classes.title} variant="subtitle1">Nº Reseñas 4-5*</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'resenyas45'}
                                value={this.state.resenyas45}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'resenyas45')}
                                onBlur={e => this.onBlur(e, 'resenyas45')}
                            />
                        </div>
                        {/* down */}
                        <div className={classes.halfPaperInsidePanel}>
                            <p className={classes.title} variant="subtitle1">Nº Reseñas 1-2-3*</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'resenyas123'}
                                value={this.state.resenyas123}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'resenyas123')}
                                onBlur={e => this.onBlur(e, 'resenyas123')}
                            />
                        </div>
                    </div>

                    <div className={classes.thirdRowCenter}>
                        {/* center */}
                        {/* up */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Hoja Reclamación</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'hojareclamacion'}
                                value={this.state.hojasReclamacion}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'hojasReclamacion')}
                                onBlur={e => this.onBlur(e, 'hojasReclamacion')}
                            />
                        </div>

                        {/* down */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Vta. Normal Bar %</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: FloatNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'ventaNormalBar'}
                                value={this.state.ventaNormalBar}
                                variant='outlined'
                            />
                        </div>
                    </div>

                    <div className={classes.thirdRowCenter}>
                        {/* center */}
                        {/* up */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Nº nuevas altas</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'altasPersonal'}
                                value={this.state.altasPersonal}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'altasPersonal')}
                                onBlur={e => this.onBlur(e, 'altasPersonal')}
                            />
                        </div>

                        {/* down */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Nº nuevas bajas</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'bajasPersonal'}
                                value={this.state.bajasPersonal}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'bajasPersonal')}
                                onBlur={e => this.onBlur(e, 'bajasPersonal')}
                            />
                        </div>
                    </div>

                    <div className={classes.thirdRowCenter}>
                        {/* center */}
                        {/* up */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Amonestaciones</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'amonestaciones'}
                                value={this.state.amonestaciones}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'amonestaciones')}
                                onBlur={e => this.onBlur(e, 'amonestaciones')}
                            />
                        </div>
                    </div>                    

                    <div className={classes.thirdRowCenter}>
                        {/* center */}
                        {/* up */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Cumples on-line</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'cumplesOnline'}
                                value={this.state.cumplesOnline}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'cumplesOnline')}
                                onBlur={e => this.onBlur(e, 'cumplesOnline')}
                            />
                        </div>

                        {/* down */}
                        <div className={classes.halfPaper}>
                            <p className={classes.title} variant="subtitle1">Entr. Kids</p>
                            <TextField
                                className={classes.textfieldHalf}
                                disabled={this.props.isSemanaCerrada}
                                placeholder={'0'}
                                InputProps={{
                                    className: classes.inputpropHalf,
                                    classes:{ input: classes.righText},
                                    inputComponent: IntNumberFormatInput
                                }}
                                inputProps={{ maxLength: 250 }}
                                id={'entrKids'}
                                value={this.state.entrKids}
                                variant='outlined'
                                onChange={e => this.handleValueChange(e, 'entrKids')}
                                onBlur={e => this.onBlur(e, 'entrKids')}
                            />
                        </div>
                    </div>               
                </div>

                <div className={classes.lastRow}>
                    {/* left */}
                    <div className={classes.paperlast}>
                        <p className={classes.title} variant="subtitle1">Resumen RRHH</p>
                        <TextField
                            className={`${classes.textField} ${classes.textfieldLast}`}
                            disabled={this.props.isSemanaCerrada ? true : false}
                            placeholder={'Escriba aquí...'}
                            InputProps={{
                                className: classes.inputprop,
                            }}
                            inputProps={{ maxLength: 250 }}
                            id={'obsResumenRRHH'}
                            value={this.state.obsResumenRRHH}
                            variant='outlined'
                            multiline
                            rowsMax="3"
                            onChange={e => this.handleValueChange(e, 'obsResumenRRHH')}
                            onBlur={e => this.onBlur(e, 'obsResumenRRHH')}
                        />
                    </div>

                    {/* left */}
                    <div className={classes.paperlast}>
                        <p className={classes.title} variant="subtitle1">Resumen Instalaciones</p>
                        <TextField
                            className={`${classes.textField} ${classes.textfieldLast}`}
                            disabled={this.props.isSemanaCerrada ? true : false}
                            placeholder={'Escriba aquí...'}
                            InputProps={{
                                className: classes.inputprop,
                            }}
                            inputProps={{ maxLength: 250 }}
                            id={'obsResumenInstalaciones'}
                            value={this.state.obsResumenInstalaciones}
                            variant='outlined'
                            multiline
                            rowsMax="3"
                            onChange={e => this.handleValueChange(e, 'obsResumenInstalaciones')}
                            onBlur={e => this.onBlur(e, 'obsResumenInstalaciones')}
                        />
                    </div>
                </div>

            </div>
        );
    };
};


CentreSection.propTypes = {
    otrosDatosCierreSemanal: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    modifyFieldOtrosDatosSemanal: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreSemanal: state.otrosDatosCierreSemanal.otrosdatos,
        isSemanaCerrada: state.datosCierreSemanal.semanaCerrada,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatosSemanal,
    }, dispatch);
};


export default connect(mapStateToProps, mapDispathToProps)(withStyles(styles, { withTheme: true })(CentreSection));